import { merge } from 'lodash-es'
import { defineStore } from 'pinia'
import { markRaw } from 'vue'

import { fetchPoll } from 'src/api/public.js'
import { vote } from 'src/api/user.js'

const POLL_INTERVAL = 30 * 1000

export const usePollsStore = defineStore('polls', {
  state: () => ({
    // Contains key = id, value = number of trackers for this poll
    trackedPolls: {},
    pollsObject: {},
    // the running loop of each tracked poll: its next timeout
    loops: markRaw(new Map()),
  }),
  actions: {
    mergeOrAddPoll(poll) {
      const existingPoll = this.pollsObject[poll.id]
      // Make expired-state change trigger re-renders properly
      poll.expired = Date.now() > Date.parse(poll.expires_at)
      if (existingPoll) {
        this.pollsObject[poll.id] = merge(existingPoll, poll)
      } else {
        this.pollsObject[poll.id] = poll
      }
    },
    // one loop per poll on screen: every 30 s while anyone tracks it; a
    // failed fetch waits for the next round
    trackPoll(pollId) {
      this.trackedPolls[pollId] = (this.trackedPolls[pollId] ?? 0) + 1
      const loops = this.loops
      if (loops.has(pollId)) return
      const round = () => {
        if (!this.trackedPolls[pollId]) {
          loops.delete(pollId)
          return
        }
        fetchPoll({ pollId })
          .then(({ data: poll }) => this.mergeOrAddPoll(poll))
          .catch(() => undefined)
          .finally(() => loops.set(pollId, setTimeout(round, POLL_INTERVAL)))
      }
      loops.set(pollId, setTimeout(round, POLL_INTERVAL))
    },
    untrackPoll(pollId) {
      this.trackedPolls[pollId] = Math.max(
        (this.trackedPolls[pollId] ?? 0) - 1,
        0,
      )
    },
    votePoll({ pollId, choices }) {
      return vote({
        pollId,
        choices,
      }).then(({ data: poll }) => {
        this.mergeOrAddPoll(poll)
        return poll
      })
    },
  },
})
